import { ObjectHelper } from 'Code/Helpers/ObjectHelper';

export class GetGridSettingsDeviceColumnStatusBaseValueConverter {
    toView(array, configuration) {
        if (ObjectHelper.IsNullOrUndefined(array) || array.length <= 0) {
            return 0;
        }
        let column: Array<any> = array.filter((item) => item['ColumnName'] == configuration.columnName);
        if (column.length == 1 && ObjectHelper.IsNotNullAndUndefined(column[0]['Status'])) {
            return column[0]['Status'];

        }

        return 0;
    }

    fromView(status, configuration) {
        let columns: Array<any> = configuration.array.filter((item) => item['ColumnName'] == configuration.columnName)
        if (columns.length > 0) {
            columns[0]['Status'] = status;
        }
        return configuration.array;
    }
}